"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.regexp.search");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    modelData: {
      default: function _default() {
        return {};
      }
    },
    queryGroup: {
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      newData: this.modelData
    };
  },
  watch: {
    modelData: {
      handler: function handler() {
        this.newData = this.modelData;
      },
      deep: true //true 深度监听
    }
  },
  mounted: function mounted() {
    this._copy = Object.assign({}, this.modelData);
    for (var k in this._copy) {
      this._copy[k] = "";
    }
  },
  methods: {
    search: function search() {
      var zhjyTableComponents = this.findBrothersComponents(this, "ZhjyPagination", false);
      if (zhjyTableComponents.length > 0) {
        zhjyTableComponents[0].changePageNum();
        this.$emit("update:pageNum", 1);
      }
      this.$emit("update:modelData", Object.assign({}, this.newData));
      this.$emit("search", this.newData);
    },
    timeCss: function timeCss(type, css) {
      if (type == "time") {
        return css;
      }
    },
    reset: function reset() {
      this.$emit("update:modelData", Object.assign({}, this._copy));
      this.newData = _objectSpread({}, this._copy);
      this.search();
    },
    dateTimeChange: function dateTimeChange(value, options) {
      if (!options) {
        return value;
      }
      this.newData[options[0]] = value[0];
      this.newData[options[1]] = value[1];
    },
    selectChange: function selectChange(change) {
      this.$emit("matchChange", change);
    },
    //当下拉框展开时callback为true 当下拉框关闭时callback为false
    visiblechange: function visiblechange(callback, change) {
      if (callback) {
        this.$emit("visiblechange2", change);
      }
    },
    findBrothersComponents: function findBrothersComponents(context, componentName) {
      var exceptMe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var _parent = context.$parent;
      var _this = "";
      if (_parent.$options._componentTag == "el-form") {
        _this = context.$parent.$parent.$children;
      } else {
        _this = context.$parent.$children;
      }
      var res = _this.filter(function (item) {
        return item.$options._componentTag === componentName;
      });
      var index = res.findIndex(function (item) {
        return item._uid === context._uid;
      });
      if (exceptMe) {
        res.splice(index, 1);
      }
      return res;
    }
  }
};